<div *ngIf="!isProduction()" style="position: absolute; top: 10px; right: 10px; z-index: 1000;">
  <select [value]="translate.currentLang" (change)="switchLang($event.target.value)">
    <option value="de">Deutsch</option>
    <option value="en">English</option>
    <option value="fr">Français</option>
    <option value="nl">Nederlands</option>
    <option value="lb">Lëtzebuergesch</option>
  </select>
</div>
<router-outlet></router-outlet>
